import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

interface ViewBudgetButtonProps {
  budgetId: number;
  showText?: boolean;
  className?: string;
}

export const ViewBudgetButton: React.FC<ViewBudgetButtonProps> = ({
  budgetId,
  showText = true,
  className = '',
}) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleView = () => {
    navigate(`/budgets/${budgetId}`);
  };

  const baseClasses =
    'flex items-center rounded-md border border-slate-500 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm hover:bg-slate-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 dark:border-slate-500 dark:bg-surface-700 dark:text-slate-300 dark:hover:bg-surface-600';
  const buttonClasses = className ? `${baseClasses} ${className}` : baseClasses;

  return (
    <button onClick={handleView} className={buttonClasses} title={t('budget.view')}>
      {showText && <span>{t('budget.view')}</span>}
    </button>
  );
};
